
export const TOGGLE_PESQUISA = '[PESQUISAPAINEL APP] TOGGLE PESQUISA';
export const CLOSE_ALL_PESQUISA = '[PESQUISAPAINEL APP] CLOSE ALL PESQUISA';

export function togglePesquisa(_AID, _ACount = null, _AClearPesquisa = null) {
    return {
        type: TOGGLE_PESQUISA,
        id: _AID,
        count: _ACount,
        clearPesquisa: _AClearPesquisa,
    }
}


export function closeAllPesquisa() {
    return {
        type: CLOSE_ALL_PESQUISA,
    }
}